var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E8F7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 25.28C25.34 21.5334 31.66 21.5334 36.5 25.28",
    stroke: "#21ADE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6333 29.4C26.1933 26.6534 30.82 26.6534 34.38 29.4",
    stroke: "#21ADE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5667 33.52C27.34 32.1467 29.66 32.1467 31.4333 33.52",
    stroke: "#21ADE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 41.3334H32.5C39.1666 41.3334 41.8333 38.6667 41.8333 32V24C41.8333 17.3334 39.1666 14.6667 32.5 14.6667H24.5C17.8333 14.6667 15.1666 17.3334 15.1666 24V32C15.1666 38.6667 17.8333 41.3334 24.5 41.3334Z",
    stroke: "#21ADE3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.fd4fea2d6a1e56c4005859d4ab1dc4d9.svg";
export { ForwardRef as ReactComponent };